import { ENVIRONMENT, appEnvironment } from 'domains/org/getty/utils/environment'

export const gettyCenterSiteId = '016e9079-0615-b58f-f447-05a98e7c9510'
export const gettyVillaSiteId = '016e907c-06ed-f9c7-0260-127351373f4a'

export const baseDeepLinkDomain = (() => {
    switch (appEnvironment) {
      case ENVIRONMENT.PROD:
        return 'https://links.getty.artpro.io'
      case ENVIRONMENT.STAGING:
        return 'https://staging.links.getty.artpro.io'
      default:
        return 'https://links.getty.artpro.io'
    }
  })()